import { HttpClient, HttpParams } from '@angular/common/http'
import { Inject, Injectable } from '@angular/core'
import { GbBaseApiService } from 'libs/shared/data-access-core/src/lib/+state/gb-base-api.service'
import { APP_CONFIG } from 'libs/shared/app-config/src/lib/gb-app-config'
import { Observable } from 'rxjs'
import { ProfilesResponse } from './profiles.models'

@Injectable({
  providedIn: 'root',
})
export class ProfilesApiService extends GbBaseApiService {
  constructor(protected http: HttpClient, @Inject(APP_CONFIG) protected appConfig: any) {
    super(http, appConfig)
  }

  getProfiles(urlName: string, limit: number, offset: number, search = ''): Observable<ProfilesResponse> {
    let params = new HttpParams().set('limit', limit).set('offset', offset)
    if (search) params = params.append('search', search)

    const url = `auctions/${urlName}/profiles/`
    return this.get<ProfilesResponse>(url, { params })
  }
}
